<template>
  <div>
    <modal-form modal-id="add-order">
      <div slot="title">Add Build Order</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-3">Name</div>
          <div class="col-lg-9">
            <input v-model="order.name" class="form-control" type="text">
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3">Client</div>
          <div class="col-lg-9">
            <v-select v-model="order.client" :options="f.clients" index="id" label="name"
                      @input="order.group = ''"></v-select>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3">Group</div>
          <div class="col-lg-9">
            <v-select v-if="order.client" v-model="order.group" :options="f.groupsByClient[order.client]" index="id"
                      label="name"></v-select>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3">Description</div>
          <div class="col-lg-9">
            <textarea v-model="order.description" class="form-control" rows="5"></textarea>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3">Domain Supplier</div>
          <div class="col-lg-9">
            <v-select v-model="order.domainSupplier" :options="['client', 'in-house']"></v-select>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3">Domain Registrars</div>
          <div class="col-lg-9">
            <v-select v-model="order.domainRegistrars" :options="f.registrars" index="id" label="name" multiple></v-select>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3">Type</div>
          <div class="col-lg-9">
            <v-select v-model="order.type" :options="types" index="id"></v-select>
          </div>
        </div>
        <div v-if="order.type === 'pbn'" class="row m-t-sm">
          <div class="col-lg-3">Size</div>
          <div class="col-lg-9">
            <input v-model="order.size" class="form-control" min="1" type="number">
          </div>
        </div>
        <div v-if="order.type === 'pbn'" class="row m-t-sm">
          <div class="col-lg-3">Target Country</div>
          <div class="col-lg-9">
            <input v-model="order.target.country" class="form-control" type="text">
          </div>
        </div>
        <div v-if="order.type === 'pbn' || order.type === 'redirect'" class="row m-t-sm">
          <div class="col-lg-3">Target Money Site</div>
          <div class="col-lg-9">
            <v-select v-model="order.target.moneySite" :options="[]" index="id" label="domain"></v-select>
          </div>
        </div>
        <div v-if="order.type" class="row m-t-sm">
          <div class="col-lg-3">Target Topic</div>
          <div class="col-lg-9">
            <v-select v-model="order.target.nicheTopic" :options="f.categories"></v-select>
          </div>
        </div>
        <div v-if="order.type" class="row m-t-sm">
          <div class="col-lg-3">
            Requirements
          </div>
          <div class="col-lg-9">
            <div class="row">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th style="text-align: center">TF</th>
                  <th style="text-align: center">RD</th>
                  <th style="text-align: center">DR</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><input v-model="order.requirements.stats.tf" class="form-control" min="0" type="number"></td>
                  <td><input v-model="order.requirements.stats.rd" class="form-control" min="0" type="number"></td>
                  <td><input v-model="order.requirements.stats.dr" class="form-control" min="0" type="number"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="order.type" class="row m-t-sm">
          <div class="col-lg-3">Hosting</div>
          <div class="col-lg-9">
            <v-select v-model="order.hosting" :options="f.hosts" index="id" label="name"></v-select>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button v-if="order.type" class="btn btn-sm btn-primary" @click="addOrder"><i class="fa fa-save"></i> Add
          Order
        </button>
      </div>
    </modal-form>
  </div>
</template>
<script>
import Form from '../../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'
import axios from 'axios'
import { FormValidation } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      order: {
        target: {},
        requirements: {
          stats: {}
        }
      },
      types: [
        { label: 'Pbn', id: 'pbn' },
        { label: 'Money Site', id: 'money' },
        { label: 'Redirect', id: 'redirect' },
        { label: 'Safe Site', id: 'safe-site' }
      ]
    }
  },
  mixins: [FormValidation],
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  components: {
    modalForm: Form
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  methods: {
    addOrder () {
      let check = this.mandatoryData(['name', 'client', 'type', 'hosting', 'domainSupplier'], this.order)
      if (check !== true) {
        this.$toastr.warning('Missing data for: ' + check.join(', '), 'I Need Some More Data')
        console.log(this.order)
        return
      }

      axios.post('/pbn/order', this.order).then(r => {
        this.$toastr.success('Order added as per your instructions sir', 'Bravissimo!')
        $('#add-order').modal('hide')
        this.$store.dispatch('loadBuildOrders')
        this.order = {
          target: {},
          requirements: {
            stats: {}
          }
        }
      }).catch(e => {
        this.$toastr.error(e, 'Error!')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Orders/AddOrderModal.vue